import { useTranslation } from "react-i18next";
import { CheckCheck } from "lucide-react";
import type { HandshakeSessionStatus } from "@/types";

interface ClosedConversationNoticeProps {
  status: HandshakeSessionStatus;
}

export function ClosedConversationNotice({
  status,
}: ClosedConversationNoticeProps) {
  const { t } = useTranslation("handshakePages");

  if (status === "CONFIRMED") {
    return (
      <p className="text-sm text-surface-600">
        <CheckCheck className="mr-1 inline h-4 w-4 text-success-500" />
        {t("agreementReached")} — {t("agreementReadOnly")}
      </p>
    );
  }
  if (status === "EXPIRED") {
    return <p className="text-sm text-surface-600">{t("conversationExpired")}</p>;
  }
  return (
    <p className="text-sm text-surface-600">{t("conversationCancelledStatus")}</p>
  );
}
